import {
  ArrowDown,
  CalendarCheck,
  Check,
  MessageCircleMore,
  Sparkles,
  Stethoscope,
  UserPlus,
} from 'lucide-react';

const STUFEN = [
  { name: 'Anfrage', detail: 'Priorisierte Behandlung', icon: UserPlus, status: 'neu' },
  { name: 'Qualifizierung', detail: 'Interesse und Eignung', icon: Sparkles, status: 'geprüft' },
  { name: 'Nachverfolgung', detail: 'Kein Kontakt geht verloren', icon: MessageCircleMore, status: 'aktiv' },
  { name: 'Beratung', detail: 'Termin und Ergebnis', icon: CalendarCheck, status: 'gebucht' },
  { name: 'Behandlung', detail: 'Quelle und Umsatz sichtbar', icon: Stethoscope, status: 'messbar' },
];

export default function GrowthSystemVisual() {
  return (
    <div className="relative mx-auto w-full max-w-[520px]" data-testid="growth-system-visual">
      <div className="absolute -inset-10 rounded-full bg-[#CC3366]/20 blur-3xl" aria-hidden="true" />
      <div className="growth-float relative overflow-hidden rounded-[28px] border border-white/15 bg-white/[0.09] p-3 shadow-[0_35px_100px_-45px_rgba(3,12,34,0.95)] backdrop-blur-xl sm:p-4">
        <div className="flex items-center justify-between border-b border-white/10 px-2 pb-3">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-white/55">Patient Growth System</p>
            <p className="mt-1 text-sm font-semibold text-white">Ein Weg. Vollständig messbar.</p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-2.5 py-1 text-[10px] font-medium text-white/75">
            <span className="h-1.5 w-1.5 rounded-full bg-[#F3A7C1]" /> Live-Ablauf
          </span>
        </div>

        <ol className="mt-3 space-y-1.5" aria-label="Ablauf des Patientengewinnungssystems">
          {STUFEN.map((stufe, index) => {
            const Icon = stufe.icon;
            return (
              <li key={stufe.name} className="relative" data-stufe-visual={index + 1}>
                <div className={`group flex items-center gap-3 rounded-2xl border px-3 py-2.5 transition duration-300 ${
                  index === STUFEN.length - 1
                    ? 'border-[#CC3366]/60 bg-[#CC3366] shadow-[0_18px_40px_-22px_rgba(204,51,102,0.9)]'
                    : 'border-white/10 bg-[#071A3B]/55 hover:-translate-y-0.5 hover:bg-white/[0.12]'
                }`}>
                  <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${index === STUFEN.length - 1 ? 'bg-white text-[#CC3366]' : 'bg-white/10 text-white'}`}>
                    <Icon className="h-4 w-4" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-semibold text-white">{stufe.name}</span>
                    <span className={`block truncate text-[11px] ${index === STUFEN.length - 1 ? 'text-white/75' : 'text-white/50'}`}>{stufe.detail}</span>
                  </span>
                  <span className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-1 text-[9px] font-semibold uppercase tracking-[0.08em] ${index === STUFEN.length - 1 ? 'bg-white/15 text-white' : 'bg-white/[0.07] text-white/55'}`}>
                    <Check className="h-2.5 w-2.5" /> {stufe.status}
                  </span>
                </div>
                {index < STUFEN.length - 1 && (
                  <ArrowDown className="mx-auto my-0.5 h-3 w-3 text-white/25" aria-hidden="true" />
                )}
              </li>
            );
          })}
        </ol>
      </div>

      <div className="growth-float-delayed absolute -right-2 -top-12 hidden rounded-2xl border border-[#0D2249]/10 bg-white px-3.5 py-2.5 text-[#0D2249] shadow-[0_22px_60px_-28px_rgba(13,34,73,0.65)] sm:block lg:-right-6">
        <p className="text-[9px] font-semibold uppercase tracking-[0.14em] text-[#68748A]">Heute beantwortet</p>
        <p className="mt-1 text-xl font-bold tracking-[-0.04em]">100 %</p>
      </div>
      <div className="growth-float absolute -left-2 -bottom-14 hidden rounded-2xl border border-[#0D2249]/10 bg-[#F2F1EF] px-3.5 py-2.5 text-[#0D2249] shadow-[0_22px_60px_-28px_rgba(13,34,73,0.65)] sm:block lg:-left-6">
        <p className="text-[9px] font-semibold uppercase tracking-[0.14em] text-[#68748A]">Nächster Schritt</p>
        <p className="mt-1 text-sm font-bold">Beratung nachfassen</p>
      </div>
    </div>
  );
}
